// components/ui/modal/ModalFooter.js
import { useKeyboardAwareBar } from "hooks/useKeyboardAwareBar";


export default function ModalFooter({ className = "", isUseKeyboardAwareBar = false, children }) {

    const barRef = useKeyboardAwareBar();
    return (
        <div
            ref={isUseKeyboardAwareBar ? barRef : null}
            className={`modal-footer tw-content-center tw-mt-auto sm:tw-mt-0 ${className}`
            }>
            {children}
        </div>
    );
}